import TemplateView from '../../../TemplateView'

export default class CustomerRow extends TemplateView
{
    constructor({
        customerModel = null,
    } = {})
    {
        super()

        this.params = {
            customerModel,
        }
    }

templateHtml() 
{
    return "" +
           "<tr class='customerRow'>" +
           "  <td class='nameColumn'><div class='subContainer'><%-name%></div></td>" +
           "  <td class='totalColumn'><div class='subContainer'><%-total%></div></td>" +
           "  <td class='detailsColumn'></td>" +
           "</tr>"
}

    templateModel()
    {
        return {
            name: ViewTTStore.getCustomer(this.params.customerModel.customerId).name,
            total: UserTime.formatTimeWithDigitSeparator(this.params.customerModel.totalSpent)
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/user/viewtt/detailsTable/CustomerRow.js